import React from "react";
import "./Footer.css";
import logo from "../../assets/logojs.png";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  // FaFax,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";

const Footer = () => {
  return (
    <section id="footer">
      <div className="container footer">
        {/* <div className="footer-box">
          <h4>Useful Links</h4>
          <div className="footer-links">
            <a href="#">&bull; Login</a>
            <a href="#">&bull; About</a>
            <a href="#">&bull; Productos y Servicios</a>
            <a href="#">&bull; Cotiza tu sitio</a>
            <a href="#subscribe">&bull; envia mensaje</a>
          </div>
        </div> */}
        <div className="footer-box">
          <h4>Bolsa de empleo</h4>
          { <div className="footer-links">
            <a href="https://empleos502.com"  target="_blank" rel="noopener noreferrer" >&bull; Ingresa tu CV </a>
            {/* <a href="">&bull; jsbackup</a>
            <a href="">&bull; Learn</a>
            <a href="">&bull; Hosting</a>
            <a href="">&bull; Whatsapp</a> */}
          </div> }
        </div>
        <div className="footer-box">
          <h4>Contact Us</h4>
          <div className="footer-contact u-text-small">
            <p>
              <FaMapMarkerAlt /> &nbsp; Address: &bull;Zona 10 Guatemala.
            </p>
            <p>
              <FaPhoneAlt /> &nbsp; Phone: 
              <a href="tel:+50256858787">&bull; +502 56858787.</a>

            </p>
            {/* <p>
              <FaFax /> &nbsp; Fax: +50242187725
            </p> */}
            <p>
              <FaEnvelope /> &nbsp; Email: help@jsbackup.com
            </p>
            <p>
              <FaGlobe /> &nbsp; Website: www.jsbackup.com
            </p>
          </div>
        </div>
        <div className="footer-box">
          <img src={logo} alt="logo" />
          <p className="u-text-small">&copy; Copyright 2025. Jsbackup.com</p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
